import { Component, HostListener } from '@angular/core';

import { FormGroup } from '@ngneat/reactive-forms';

@Component({
  template: '',
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class SubmitOnEnter {
  abstract form: FormGroup<any>;
  abstract submitForm(): void;

  @HostListener('document:keydown.enter') onEnter() {
    if (this.form.invalid) {
      return;
    }

    this.submitForm();
  }
}
